"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultValues = void 0;
const __1 = require("../..");
exports.defaultValues = {
    [__1.StorageKey.TRANSPORT_P2P_PEERS]: [],
    [__1.StorageKey.ACCOUNTS]: [],
    [__1.StorageKey.ACTIVE_ACCOUNT]: undefined,
    [__1.StorageKey.BEACON_SDK_SECRET_SEED]: undefined,
    [__1.StorageKey.APP_METADATA_LIST]: [],
    [__1.StorageKey.PERMISSION_LIST]: [],
    [__1.StorageKey.BEACON_SDK_VERSION]: undefined
};
//# sourceMappingURL=StorageKeyReturnDefaults.js.map